import * as _ from 'lodash';
import * as angular from 'angular';
import * as template from './template.html';
import './styling.scss';
import {
    getSmartHomeKitProvider,
    getSmartHomeStarterKitDiscountRemovalDate,
    isAdvancedSmartHomeKit
} from 'common/source/utilities/policyInfoHelper';
import { AMERICAN_DATE_FORMAT_ORDINAL_MEDIUM } from 'common/source/utilities/dates';
import { getFormattedPhoneNumber } from 'common/source/utilities/strings';
import * as hippoConstFactory from 'common/hippoConst.js';

const module = angular.module('smart-home-starter-kit-section', []);

const PROVIDER = {
    NOTION: 'Notion',
    SIMPLISAFE: 'Simplisafe',
    KANGAROO: 'Kangaroo'
};
interface SmartHomeStarterKitSectionController extends angular.IStrictController {
    policyInfo: CustomerPolicyInfo;
    title: string;
    description: string;
    policyId: PolicyId;
    smartHomeDiscount: number;
}

module.component('smartHomeStarterKitSection', {
    template: template,
    bindings: {
        policyInfo: '<',
        smartHomeDiscount: '<'
    },
    controller: function(this: SmartHomeStarterKitSectionController) {
        const HIPPO_CONSTS = hippoConstFactory();

        this.$onInit = () => {
            this.policyId = this.policyInfo.id;

            let smartHomeProviderName = _.startCase(getSmartHomeKitProvider(this.policyInfo) || PROVIDER.NOTION);
            let smartHomeProviderEmail;
            let smartHomeProviderPhoneNumber;

            switch(smartHomeProviderName) {
                case PROVIDER.NOTION:
                    smartHomeProviderEmail = HIPPO_CONSTS.NOTION_SUPPORT_EMAIL;
                    smartHomeProviderPhoneNumber = HIPPO_CONSTS.NOTION_PHONE_NUMBER;
                    break;
                case PROVIDER.SIMPLISAFE:
                    smartHomeProviderEmail = HIPPO_CONSTS.SIMPLISAFE_SUPPORT_EMAIL;
                    smartHomeProviderPhoneNumber = HIPPO_CONSTS.SIMPLISAFE_PHONE_NUMBER;
                    break;
                default:
                    smartHomeProviderEmail = HIPPO_CONSTS.KANGAROO_SUPPORT_EMAIL;
                    smartHomeProviderPhoneNumber = HIPPO_CONSTS.KANGAROO_PHONE_NUMBER;
            }

            const discountValue = this.smartHomeDiscount;

            this.title = 'Activate your Smart Home Sensor Kit';
            const isAdvancedSmartKit = isAdvancedSmartHomeKit(this.policyInfo);
            if (isAdvancedSmartKit && discountValue > 0) {
                this.title = 'Activate your Advance Smart Home Discount';
                smartHomeProviderName = PROVIDER.SIMPLISAFE;
                smartHomeProviderEmail = HIPPO_CONSTS.SIMPLISAFE_SUPPORT_EMAIL;
                smartHomeProviderPhoneNumber = HIPPO_CONSTS.SIMPLISAFE_PHONE_NUMBER;
            }

            const noDiscountMessage = `
                Activate your complimentary smart home monitoring system that can alert you to water leaks, movement,
                temperature changes and smoke alarms to help keep your home safe. Look for your kit in the mail within 2
                weeks after your policy effective date. Any questions about how to activate your devices, contact ${smartHomeProviderName} at
                <a href="mailto:${smartHomeProviderEmail}">${smartHomeProviderEmail}</a> or
                <a href="tel:${smartHomeProviderPhoneNumber}">${getFormattedPhoneNumber(
                smartHomeProviderPhoneNumber
            )}</a>.`;

            const removalDateFormatted = getSmartHomeStarterKitDiscountRemovalDate(this.policyInfo).format(
                AMERICAN_DATE_FORMAT_ORDINAL_MEDIUM
            );
            const discountMessage = `
            Activate your complimentary smart home monitoring system that can alert you to water leaks, movement,
            temperature changes and smoke alarms - activate by ${removalDateFormatted} to lock in your discount for the
            full year. Look for your kit in the mail within 2 weeks after your policy effective date. Any questions about how
            to activate your devices, contact ${smartHomeProviderName} at <a href="mailto:${smartHomeProviderEmail}">${smartHomeProviderEmail}</a> or
            <a href="tel:${smartHomeProviderPhoneNumber}">${getFormattedPhoneNumber(
                smartHomeProviderPhoneNumber
            )}</a>.`;

            const advancedMessage = `Don’t forget to activate your Simplisafe whole-home security  system - 
            activate by ${removalDateFormatted} to lock in your discount for the full year.
            Look for your devices in the mail within 2 weeks after your policy effective date.
            Any questions about how to activate your devices, contact ${smartHomeProviderName} at <a href="mailto:${smartHomeProviderEmail}">${smartHomeProviderEmail}</a> or
            <a href="tel:${smartHomeProviderPhoneNumber}">${getFormattedPhoneNumber(
                smartHomeProviderPhoneNumber
            )}</a>.`;

            this.description =
                discountValue > 0 ? (isAdvancedSmartKit ? advancedMessage : discountMessage) : noDiscountMessage;
        };
    }
});

export { module };
